import { FC, ReactNode } from "react";
import { ConfigProvider, locales } from "@payping/web-components";

interface Props {
  children?: ReactNode;
}

const Wrapper: FC<Props> = (props) => {
  const { children } = props;
  return (
    <ConfigProvider componentSize={"large"} direction={"rtl"} locale={locales.faIR}>
      {children}
    </ConfigProvider>
  );
};

export default Wrapper;
